import { TableHead } from "@material-ui/core"
import styled from "styled-components"

export const THead = styled(TableHead)``
